import { TooltipDirective } from '../../../../auxiliares/tooltip/tooltip.directive';
import { BOTONES } from '../../../../componentes/botones';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  ICliente,
  ICreateServicio,
  IQueryParam,
  IUpdateServicio,
  IServicio,
  TipoServicio,
  IProveedor,
  IActivo,
  IFilter,
  IUsuario,
  CategoriaProveedor,
  CategoriaServicio,
  TipoProveedor,
} from 'modelos/src';
import { Subscription, firstValueFrom } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiciosService } from '../../../../auxiliares/servicios/http/servicios.service';
import { CrearEditarProveedorComponent } from '../../../standalone/proveedores/crear-editar-proveedor/crear-editar-proveedor.component';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormularioDialogService } from '../../../../auxiliares/servicios/formulario-dialog.service';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { LoginService } from '../../../login/login.service';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';

import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { NgSelectModule } from '@ng-select/ng-select';
import { ButtonComponent } from '../../../../auxiliares/button/button.component';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { ClienteSelectorComponent } from '../../../../componentes/selectores/cliente-selector/cliente-selector.component';
import { ContentCardComponent } from '../../../../componentes/content-card/content-card.component';
import { CardHeaderComponent } from '../../../../componentes/card-header/card-header.component';
import { LoadingComponent } from '../../../../componentes/loading/loading.component';
import { UsuarioSelectorComponent } from '../../../../componentes/selectores/usuario-selector/usuario-selector.component';
import { UploadFileComponent } from '../../../../auxiliares/upload-file/upload-file.component';

const servicioToProveedorMap: Partial<Record<TipoServicio, TipoProveedor[]>> = {
  Gasto: undefined,
  Combustible: ['Combustible'],
  Mantenimiento: ['Mecanico', 'Otro'],
};

@Component({
  selector: 'app-crear-editar-servicio',
  templateUrl: './crear-editar-servicio.component.html',
  styleUrl: './crear-editar-servicio.component.scss',
  standalone: true,
  imports: [TooltipDirective, BOTONES, 
    ReactiveFormsModule,
    MatDialogModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatDividerModule,
    NgSelectModule,
    ButtonComponent,
    MatIconModule,
    ClienteSelectorComponent,
    ContentCardComponent,
    CardHeaderComponent,
    LoadingComponent,
    UsuarioSelectorComponent,
    UploadFileComponent,
  ],
})
export class CrearEditarServicioComponent implements OnInit, OnDestroy {
  dialogRef = inject<MatDialogRef<CrearEditarServicioComponent>>(MatDialogRef, {
    optional: true,
  });
  private route = inject(ActivatedRoute);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private formularios = inject(FormularioDialogService);
  private navigator = inject(Router);
  private service = inject(ServiciosService);
  private dialogService = inject(DialogService);

  public name = 'CrearEditarServicioComponent';
  public form?: FormGroup;
  public title?: string;
  public tipos: TipoServicio[] = ['Gasto', 'Mantenimiento', 'Combustible'];
  public tiposProveedor: TipoProveedor[] = ['Mecanico', 'Combustible', 'Otro'];
  public id?: string | null;
  public servicio?: IServicio;
  public activos?: IActivo[] = [];
  public activos$?: Subscription;
  public proveedores?: IProveedor[] = [];
  public proveedores$?: Subscription;
  public usuarios: IUsuario[] = [];
  public usuarios$?: Subscription;

  public clientePropio = LoginService.getCliente();
  public clienteElegido: ICliente;
  public tipoCliente = HelperService.getTipoCliente();
  public tipoElegido: TipoServicio;
  public categoria: CategoriaProveedor = 'Vehiculo';
  // public tipoProveedorElegido?: TipoProveedor; // Eliminado, usamos el mapa
  public tiposProveedorFiltro: TipoProveedor[] | undefined;

  // Propiedades para controlar si es servicio de combustible
  get esCombustible(): boolean {
    // Se usa el tipo de servicio directo ahora
    return this.tipoElegido === 'Combustible';
  }

  // Campo actualmente enfocado para el cálculo de combustible
  public campoFocused: 'litrosCargados' | 'precioPorLitro' | 'costo' | null =
    null;
  // Historial de edición para saber cuál campo recalcular cuando los 3 tienen valor
  private combustibleEditOrder: string[] = [];

  get datosPersonales() {
    return this.form?.get('datosPersonales') as FormGroup;
  }

  public loading: boolean = true;

  /**
   * Elimina el obtendor de tipo proveedor por tipo de servicio.
   * En vez de eso, usa el servicioToProveedorMap flexible.
   */

  private createForm() {
    // Determinar el cliente por defecto basado en el tipo de usuario
    const clienteDefault =
      this.tipoCliente === 'Final'
        ? this.clientePropio._id
        : this.servicio?.idCliente;

    this.form = new FormGroup({
      categoria: new FormControl(this.categoria, Validators.required),
      tipo: new FormControl(this.servicio?.tipo, Validators.required),
      // tipoProveedor: new FormControl(this.tipoProveedorElegido), // ya no usado como campo visible
      idCliente: new FormControl(clienteDefault, Validators.required),
      idActivo: new FormControl(this.servicio?.idActivo, Validators.required),
      idProveedor: new FormControl(this.servicio?.idProveedor),
      fechaRealizacion: new FormControl(this.servicio?.fechaRealizacion),
      nombreChofer: new FormControl(this.servicio?.nombreChofer),
      idUsuario: new FormControl(this.servicio?.idUsuario),
      fotos: new FormControl(this.servicio?.fotos || []),
      detalles: new FormControl(this.servicio?.detalles),
      kmDelMantenimiento: new FormControl(this.servicio?.kmDelMantenimiento),
      costo: new FormControl(this.servicio?.costo),
      litrosCargados: new FormControl(this.servicio?.litrosCargados),
      precioPorLitro: new FormControl(null),
    });
  }

  /**
   * Activo a preseleccionar cuando el alta viene del detalle de un vehículo.
   * Se aplica recién cuando llegan las opciones del select: ng-select no puede
   * mostrar un valor que todavía no está en `activos`.
   */
  private idActivoPendiente?: string;

  private aplicarActivoPendiente(): void {
    if (!this.idActivoPendiente || !this.form) return;
    if (!this.activos?.some((a) => a._id === this.idActivoPendiente)) return;
    this.form.patchValue({ idActivo: this.idActivoPendiente });
    this.idActivoPendiente = undefined;
  }

  private async listarActivos() {
    const filter: IFilter<IActivo> = {};
    if (this.clienteElegido?._id) {
      filter['idCliente'] = this.clienteElegido._id;
    }
    const query: IQueryParam = {
      unlimited: true,
      includeChildren: true,
      filter: JSON.stringify(filter),
    };

    if (this.categoria === 'Colectivo') {
      this.activos$?.unsubscribe();
      this.activos$ = this.lista2.colectivos(query).subscribe((data) => {
        this.activos = data.datos;
      });
    }
    if (this.categoria === 'Vehiculo') {
      this.activos$?.unsubscribe();
      this.activos$ = this.lista2.vehiculos(query).subscribe((data) => {
        this.activos = data.datos;
        this.aplicarActivoPendiente();
      });
    }
  }

  private async listarProveedores() {
    const filter: IFilter<IProveedor> = {
      categoria: this.categoria,
    };

    // Filtrado de tipo de proveedor basado en servicioToProveedorMap
    if (
      this.tipoElegido &&
      Object.prototype.hasOwnProperty.call(
        servicioToProveedorMap,
        this.tipoElegido,
      )
    ) {
      this.tiposProveedorFiltro = servicioToProveedorMap[this.tipoElegido];
      if (this.tiposProveedorFiltro) {
        filter.tipos = { $in: this.tiposProveedorFiltro };
      }
    } else {
      this.tiposProveedorFiltro = undefined;
    }

    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      select: 'nombre categoria tipos idCliente',
      sort: 'nombre',
      includeChildren: true,
    };
    this.proveedores$?.unsubscribe();
    this.proveedores$ = this.lista2.proveedors(query).subscribe((data) => {
      this.proveedores = data.datos;
    });
  }

  private async getServicio() {
    if (this.id) {
      this.servicio = await firstValueFrom(this.lista2.servicio(this.id!));
    }
  }

  //
  public async onSubmit() {
    const res = await this.dialogService.confirm(
      `${this.title} Servicio`,
      `¿Querés ${this.title} el servicio?`,
    );
    if (!res) return;
    this.loading = true;
    try {
      const data = this.getData();
      if (this.id) {
        // Update
        await this.service.update(this.id, data);
        this.helper.notifSuccess('Servicio actualizado');
        HelperService.volver();
      } else {
        // Create
        await this.service.create(data);
        this.helper.notifSuccess('Servicio creado');
        HelperService.volver();
      }
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  public crearProveedor() {
    const dialog = this.formularios.abrir(CrearEditarProveedorComponent, {
      tamano: 'mediano',
      data: {
        categoria: this.categoria,
      },
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.listarProveedores();
        this.form.patchValue({
          idProveedor: res?._id,
        });
      }
    });
  }

  public crearRecordatorio() {
    this.navigator.navigate(['/', 'main', 'servicios', 'recordatorio']);
  }

  public getData(): ICreateServicio | IUpdateServicio {
    const formValue = this.form?.value;
    // Eliminar campos que no son parte del modelo de servicio
    const { precioPorLitro, ...data } = formValue;
    return data;
  }

  // Evento cuando cambia el cliente seleccionado
  public onClienteChange(cliente: ICliente): void {
    this.clienteElegido = cliente;

    // Limpiar selecciones actuales de vehículo y proveedor
    this.form?.patchValue({
      idActivo: null,
      idProveedor: null,
      nombreChofer: null,
      idUsuario: null,
    });

    // Recargar listas filtradas por cliente
    if (cliente) {
      this.listarActivos();
      this.listarProveedores();
    } else {
      this.activos = [];
      this.proveedores = [];
      this.usuarios = [];
    }
  }

  public onTipoChange(tipo: TipoServicio): void {
    if (!tipo) {
      this.tipoElegido = undefined;
      this.tiposProveedorFiltro = undefined;
      this.proveedores = [];
      return;
    }

    this.tipoElegido = tipo;

    // Limpiar proveedor seleccionado
    this.form?.patchValue({
      idProveedor: null,
    });

    // Si cambia a/de combustible, limpiar campos específicos
    if (tipo !== 'Combustible') {
      this.form?.patchValue({
        litrosCargados: null,
        precioPorLitro: null,
      });
    }

    // Recargar proveedores filtrados si ya hay un cliente seleccionado
    this.listarProveedores();
  }

  // Función para agregar un nombre personalizado
  public addCustomName = (nombre: string): any => {
    return { nombreCompleto: nombre };
  };

  private autocompletarCombustibleInicial(): void {
    if (!this.esCombustible) return;

    const litros = Number(this.form?.get('litrosCargados')?.value);
    const costo = Number(this.form?.get('costo')?.value);

    if (litros > 0 && costo > 0) {
      const precioPorLitro = parseFloat((costo / litros).toFixed(2));
      this.form?.patchValue({ precioPorLitro }, { emitEvent: false });
    }
  }

  /**
   * Calcula automáticamente el tercer campo de combustible.
   * - Si solo 2 campos tienen valor, calcula el que está vacío.
   * - Si los 3 tienen valor, recalcula el que NO está enfocado y fue editado
   *   menos recientemente.
   */
  public calcularCombustible(
    campoEditado: 'litrosCargados' | 'precioPorLitro' | 'costo',
  ): void {
    // Actualizar historial de edición
    this.combustibleEditOrder = this.combustibleEditOrder.filter(
      (c) => c !== campoEditado,
    );
    this.combustibleEditOrder.push(campoEditado);

    const litros = Number(this.form?.get('litrosCargados')?.value) || 0;
    const precio = Number(this.form?.get('precioPorLitro')?.value) || 0;
    const costo = Number(this.form?.get('costo')?.value) || 0;

    const campos = [
      { key: 'litrosCargados', val: litros },
      { key: 'precioPorLitro', val: precio },
      { key: 'costo', val: costo },
    ];

    const sinValor = campos.filter((c) => c.val <= 0);

    // Si hay exactamente 1 campo vacío y NO es el que el usuario está editando → calcular el vacío
    if (sinValor.length === 1 && sinValor[0].key !== campoEditado) {
      this.calcularCampo(sinValor[0].key, litros, precio, costo);
      return;
    }

    // Si los 3 tienen valor → recalcular el menos reciente que NO es el enfocado
    if (sinValor.length === 0) {
      const candidatos = campos
        .map((c) => c.key)
        .filter((k) => k !== this.campoFocused);

      // Elegir el que fue editado menos recientemente
      let aRecalcular = candidatos[0];
      for (const c of candidatos) {
        const idx = this.combustibleEditOrder.indexOf(c);
        const idxActual = this.combustibleEditOrder.indexOf(aRecalcular);
        if (idx < idxActual || idx === -1) {
          aRecalcular = c;
        }
      }

      this.calcularCampo(aRecalcular, litros, precio, costo);
    }
  }

  private calcularCampo(
    campo: string,
    litros: number,
    precio: number,
    costo: number,
  ): void {
    switch (campo) {
      case 'litrosCargados':
        if (precio > 0) {
          this.form?.patchValue(
            { litrosCargados: parseFloat((costo / precio).toFixed(2)) },
            { emitEvent: false },
          );
        }
        break;
      case 'precioPorLitro':
        if (litros > 0) {
          this.form?.patchValue(
            { precioPorLitro: parseFloat((costo / litros).toFixed(2)) },
            { emitEvent: false },
          );
        }
        break;
      case 'costo':
        if (litros > 0 && precio > 0) {
          this.form?.patchValue(
            { costo: parseFloat((litros * precio).toFixed(2)) },
            { emitEvent: false },
          );
        }
        break;
    }
  }

  // Evento cuando cambia el conductor/chofer seleccionado
  public onConductorChange(value: any): void {
    if (!value) {
      // Permitir deseleccionar
      this.form?.patchValue({
        nombreChofer: null,
      });
      return;
    }

    // Si es un objeto (usuario de la lista o tag personalizado), extraer nombreCompleto
    if (typeof value === 'object' && value.nombreCompleto) {
      this.form?.patchValue({
        nombreChofer: value.nombreCompleto,
      });
    } else if (typeof value === 'string') {
      // Si por alguna razón es un string directo
      this.form?.patchValue({
        nombreChofer: value,
      });
    }
  }

  async ngOnInit() {
    const params = await firstValueFrom(this.route.paramMap);
    this.id = params.get('id');
    this.categoria = params.get('categoria') as CategoriaServicio;
    // Alta desde el detalle de un vehículo: el activo y su cliente llegan por
    // query param (ver ListadoServiciosComponent.crear)
    const query = await firstValueFrom(this.route.queryParamMap);
    const idActivoPreseleccionado = query.get('idActivo');
    const idClientePreseleccionado = query.get('idCliente');
    this.title = this.id ? 'Editar Servicio' : 'Crear Servicio';
    if (this.id) {
      await this.getServicio();
      // Establecer el tipo de proveedor según el tipo de servicio
      if (this.servicio?.tipo) {
        this.tipoElegido = this.servicio.tipo;
        this.tiposProveedorFiltro = servicioToProveedorMap[this.servicio.tipo];
      }
    }

    this.createForm();
    if (this.id) {
      this.autocompletarCombustibleInicial();
    }

    // Establecer cliente elegido
    if (this.tipoCliente === 'Final') {
      // Usuario final: usar su cliente
      this.clienteElegido = this.clientePropio;
      this.form.patchValue({
        idCliente: this.clientePropio?._id,
      });
    } else if (this.id && this.servicio?.idCliente) {
      this.clienteElegido = { _id: this.servicio.idCliente } as ICliente;
    } else if (!this.id && idClientePreseleccionado) {
      this.clienteElegido = { _id: idClientePreseleccionado } as ICliente;
      this.form.patchValue({ idCliente: idClientePreseleccionado });
    }

    if (!this.id && idActivoPreseleccionado) {
      this.idActivoPendiente = idActivoPreseleccionado;
    }

    if (this.clienteElegido) {
      this.listarActivos();
    }
    // Por si los activos ya estaban en cache y la emisión fue sincrónica
    this.aplicarActivoPendiente();

    await Promise.all([this.listarProveedores()]);

    this.loading = false;
  }

  ngOnDestroy(): void {
    this.proveedores$?.unsubscribe();
    this.activos$?.unsubscribe();
    this.usuarios$?.unsubscribe();
  }
}
